import request, { ApiResponse } from './request';
import { Customer } from '@/types';

export interface CustomerFormData {
  name: string;
  village: string;
  avatar?: string;
  phone?: string;
}

export interface CustomerListResponse {
  list: Customer[];
  surnames: { surname: string; count: number }[];
  villages: { village: string; count: number }[];
}

export interface CustomerDetailResponse {
  customer: Customer;
  salesRecords: any[];
  sameVillageCustomers: Customer[];
}

export function getCustomers(params?: {
  keyword?: string;
  surname?: string;
  village?: string;
}, signal?: AbortSignal): Promise<ApiResponse<CustomerListResponse>> {
  return request.get('/customers', { params, signal });
}

export function getCustomerDetail(id: number): Promise<ApiResponse<CustomerDetailResponse>> {
  return request.get(`/customers/${id}`);
}

export function createCustomer(data: CustomerFormData): Promise<ApiResponse<Customer>> {
  return request.post('/customers', data);
}

export function updateCustomer(id: number, data: CustomerFormData): Promise<ApiResponse<Customer>> {
  return request.put(`/customers/${id}`, data);
}

export function deleteCustomer(id: number): Promise<ApiResponse<null>> {
  return request.delete(`/customers/${id}`);
}

export function getCustomersByVillage(village: string): Promise<ApiResponse<Customer[]>> {
  return request.get(`/customers/village/${encodeURIComponent(village)}`);
}
